/** @format */
import styled from 'styled-components';

import { StyledSectionPreviewBlock } from '../section-preview-block.styles';
import { StyledSectionPreviewBlockProps } from '../types';

export const StyledSectionPreviewBlockSkeleton = styled(
    StyledSectionPreviewBlock
)<StyledSectionPreviewBlockProps>`
    .image-skeleton {
        width: 100%;
        height: 100%;
    }
`;
